import React, { useState } from 'react'
import Modal from 'react-modal';
import { IoClose } from "react-icons/io5";
import CareerService from '../../services/career.service';
import fileService from '../../services/file.service';

const customStyles = {
  overlay: {
    zIndex:"99999",
    backgroundColor: 'rgba(0, 0, 0, 0.66)',
    overflow:"scroll"
  },
  content: {
    marginTop:"150px",
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    // marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
  },
};

const PopupForm = ({closeModal,modalIsOpen,jobData}) => {
  const form=document.getElementById("popupForm");
  const intialState={
    name:"",
    phone:"",
    email:"",
    resume:null,
    position:"",
    message:"",
  }
  const [formState,setFormState]=useState({...intialState,position:jobData.name});
  const [error,setError]=useState({...intialState});
  const [loading,setLoading]=useState(false);

  

  const handleChange=(e)=>{
    const {name,value,files}=e.target;

    // !form.classList.contains("was-validated") && form.classList.add("was-validated");
    setError(prev=>({...prev,[name]:""}))

    if(files){
      console.log(files[0])
      fileService.upload(files[0])
      .then(res=>{console.log(res);
        setFormState(prevState=>({...prevState,resume:res.data.url})) })
      .catch(err=>console.log(err))
    }else{
    setFormState(prevState=>({...prevState,[name]:value}));
    }
  };


  const validate = () => {
    let errors = {};

    // Name validation (required and alphabets only)
    if (!formState.name.trim()) {
      errors.name = "Name is required";
    } else if (!/^[A-Za-z\s]+$/.test(formState.name)) {
      errors.name = "Name can only contain alphabets";
    }

    // Phone number validation (required and numbers only)
    if (!formState.phone.trim()) {
      errors.phone = "Phone number is required";
    } else if (!/^\d{10}$/.test(formState.phone)) {
      errors.phone = "Phone number must be 10 digits";
    }

    // Email validation (required and valid email format)
    if (!formState.email.trim()) {
      errors.email = "Email is required";
    } else if (!/^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]{2,7}$/.test(formState.email)) {
      errors.email = "Please enter a valid email address";
    }

    // Resume validation (required)
    if (!formState.resume) {
      errors.resume = "Resume is required";
    }

    // Message validation (optional but length check)
    if (formState.message && formState.message.length > 500) {
      errors.message = "Message cannot exceed 500 characters";
    }
     if( !formState.message){
      errors.message="Message is required"
    }

    setError(errors);
    return Object.keys(errors).length === 0; // Returns true if no errors
  };



  const handleSubmit= async (e)=>{
    e.preventDefault();

    if(!validate()){
    e.target.classList.add("was-validated");
    return;
    }


    try {
      setLoading(true);
      const {name,phone,email,resume,message,position}=formState;
      const formData=new FormData();
      formData.append("name",name);
      formData.append("phone",phone);
      formData.append("email",email);
      formData.append("resume",resume);
      formData.append("message",message);
      formData.append("position",position);

   const res=await CareerService.save(formState);
   if(res.success){
    alert(res.message);
    setFormState({...intialState});
   }



      
    } catch (error) {
      console.log(error);
      
    }finally{
      setLoading(false);
    }
  }

  return (
    <>
 <div>
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        style={customStyles}
        contentLabel="Example Modal" 
        className={"col-md-6 col-10 bg-white rounded-3 p-md-4 p-3 position-absolute top-50 left-50 translate-middle border-0 m-md-0 outline-none"}
      >
          <div className=' rounded-3 pb-5'>
            <div className='d-flex justify-content-between'>
    <h4 className='text-black fw-bold'>Apply for {jobData?.name}</h4>
              <IoClose onClick={closeModal} style={{cursor:"pointer"}} className='fs-md-3 fs-1'/>
            </div>
    <form onSubmit={handleSubmit} noValidate id='popupForm'>
      <div className='row row-cols-md-2'>
      <div className='col-md-6 mb-3'>
            <label className='form-label fw-bold'>Name</label>
            <input type='text' name='name' placeholder='Name' onChange={handleChange} style={{backgroundColor:"#ECECEC"}} className={'form-control ' + (error.name && ' is-invalid')} required/>
            {/* <p className='valid-feedback'>Looks Good !</p> */}
            <p className='invalid-feedback'>{error.name}</p>
        </div>
        <div className=' col-md-6 mb-3'>
            <label className='form-label fw-bold'>Phone No.</label>
            <input type='Number' name='phone' placeholder='Phone' minLength={10} maxLength={10} onChange={handleChange} style={{backgroundColor:"#ECECEC"}} className={'form-control ' + (error.phone && ' is-invalid')}  required/>
            {/* <p className='valid-feedback'>Looks Good!</p> */}
            <p className='invalid-feedback'>{error.phone}</p>
        </div>      
         <div className='col-md-6 mb-3'>
            <label className='form-label fw-bold'>Email</label>
            <input type='text' name='email' placeholder='Email' onChange={handleChange} style={{backgroundColor:"#ECECEC"}} className={'form-control ' + (error.email && ' is-invalid')}  required/>
            {/* <p className='valid-feedback'> Looks Good !</p> */}
            <p className='invalid-feedback'>{error.email}</p>
        </div>
        <div className='col-md-6 mb-3'>
            <label className='form-label fw-bold'>Upload Resume/CV</label>
            <input type='file' name='resume'  onChange={handleChange}  style={{backgroundColor:"#ECECEC"}} className={'form-control ' +(error.resume && ' is-invalid')}  required/>
            {/* <p className='valid-feedback'>Looks Good !</p> */}
            <p className='invalid-feedback'>{error.resume}</p>
        </div>

      </div>
  
        <div className='mb-3'>
            <label className='form-label fw-bold'>Message</label>
            <textarea name='message' style={{backgroundColor:"#ECECEC"}}  onChange={handleChange} className={'form-control px-4 py-3' + (error.message && ' is-invalid')} rows={8} placeholder='Message' required></textarea>
            {/* <p className='valid-feedback'>Looks Good !</p> */}
            <p className='invalid-feedback'>{error.message}</p>
        </div>
      <button style={{backgroundColor:"#FE7743"}} type='submit' className='btn btn-danger w-100 mt-3 border-0 py-2'>{loading? <div className='spinner-border spinner-border-sm'><div className='visually-hidden'>loading...</div></div>:"Apply Now"}</button>

    </form>

   </div>
      </Modal>
    </div>
    </>
  )
}

export default PopupForm;